import React, { useState, useEffect, useMemo } from "react";
import { useLocation, Route, Routes, Navigate } from "react-router-dom";

import AdminNavbar from "components/Navbars/AdminNavbar.js";
import AdminFooter from "components/Footers/AdminFooter.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import PageHeader from "components/ui/PageHeader";

import routes from "routes.js";
import routes2 from "routes2";
import getDecodedToken from "services/getDecodedToken";

const greeting = () => {
  const h = new Date().getHours();
  if (h < 12) return "Good morning";
  if (h < 18) return "Good afternoon";
  return "Good evening";
};

const Admin = (props) => {
  const mainContent = React.useRef(null);
  const location = useLocation();
  const [isEmployee, setIsEmployee] = useState(false);

  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    if (mainContent.current) mainContent.current.scrollTop = 0;
  }, [location]);

  useEffect(() => {
    const decoded = getDecodedToken();
    if (decoded?.authorities?.includes("Employe")) setIsEmployee(true);
  }, []);

  const activeRoutes = isEmployee ? routes2 : routes;

  const getRoutes = (rts) =>
    rts.map((prop, key) =>
      prop.layout === "/admin" ? (
        <Route path={prop.path} element={prop.component} key={key} />
      ) : null
    );

  const sidebarRoutes = useMemo(
    () => activeRoutes.filter((r) => r.sidebar !== false),
    [activeRoutes]
  );

  const brandText = useMemo(() => {
    for (let r of activeRoutes) {
      if (location.pathname.indexOf((r.layout || "") + r.path) !== -1) return r.name;
    }
    return "Dashboard";
  }, [activeRoutes, location.pathname]);

  const decoded = getDecodedToken() || {};
  const name = decoded.username || (decoded.sub ? decoded.sub.split("@")[0] : "Admin");

  return (
    <>
      <Sidebar routes={sidebarRoutes} logo={{ innerLink: "/admin/index" }} />
      <main className="pm-main" ref={mainContent}>
        <AdminNavbar brandText={brandText} profilePath="/admin/Profile" />
        <PageHeader
          role="admin"
          eyebrow="System Admin · Platform"
          title={`${greeting()}, ${name}`}
          subtitle={brandText}
        />
        <div className="ph-pull">
          <Routes>
            {getRoutes(activeRoutes)}
            <Route path="*" element={<Navigate to="/admin/index" replace />} />
          </Routes>
        </div>
        <AdminFooter />
      </main>
    </>
  );
};

export default Admin;
